module.exports = __webpack_public_path__ + "static/media/landing-2.d1a06759.jpg";